import type { StaticLayerPayload } from "@config";
import { CalendarLibrary } from "@library-elements/calendar";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: CalendarLibrary,
};

export const Calendar = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
